import { useState } from "react";

const INITIAL_DIALOG = {
  open: false,
  title: "",
  message: "",
  confirmText: "",
  cancelText: "",
  variant: "default", // default | danger | payment
  loading: false,
  onConfirm: null,
};

export default function useLivoraDialog() {
  const [dialog, setDialog] = useState(INITIAL_DIALOG);

  const openDialog = ({
    title = "",
    message = "",
    confirmText = "OK",
    cancelText = "Cancel",
    variant = "default",
    onConfirm = null,
  }) => {
    setDialog({
      open: true,
      title,
      message,
      confirmText,
      cancelText,
      variant,
      loading: false,
      onConfirm,
    });
  };

  // إغلاق عادي: يمنع الإغلاق أثناء المعالجة
  const closeDialog = () => {
    setDialog((prev) => {
      if (prev.loading) return prev;
      return INITIAL_DIALOG;
    });
  };

  // إغلاق قسري: يغلق حتى لو loading=true
  const forceCloseDialog = () => {
    setDialog(INITIAL_DIALOG);
  };

  const setDialogLoading = (loading) => {
    setDialog((prev) => ({ ...prev, loading }));
  };

  return {
    dialog,
    openDialog,
    closeDialog,
    forceCloseDialog,
    setDialogLoading,
  };
}